import axios from '@/utils/request'
export function get_highscore_game_list(data) {
  return axios({
    url: '/game/discount_game_list',
    method: 'post',
    data: data
  })
}
export function gm_game_list(data) {
  return axios({
    url: '/game/gm_game_list',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/game.js